import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab2 = ({ WarrantyExpiryDate, AmcExpiryDate }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Warranty / AMC Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
          type="date"
            id="WarrantyExpiryDate"
            label="Warranty Expiry Date"
            style={{
              height: "38px",
              border: WarrantyExpiryDate?.Error ? "1px solid red" : "",
            }}
            value={WarrantyExpiryDate?.WarrantyExpiryDate || ""}
            onChange={(e) => WarrantyExpiryDate?.setWarrantyExpiryDate?.(e.target.value)}
          />
        </div>
      </div>

      <div className="col-6">
        <div className="mb-3">
          <Input
           type="date"
            id="AmcExpiryDate"
            style={{
              height: "38px",
              border: AmcExpiryDate?.Error ? "1px solid red" : "",
            }}
            label="AMC Expiry Date"
          
            value={AmcExpiryDate?.AmcExpiryDate || ""}
                onChange={(e) => AmcExpiryDate?.setAmcExpiryDate?.(e.target.value)}
        
          />
        </div>
      </div>
    </div>
  );
};

export default Tab2;